export function initPhone(){
    const phoneInputs = document.querySelectorAll<HTMLInputElement>('input[type="tel"]');

    phoneInputs.forEach((input) => {
        input.addEventListener("focus", () => {
            if (!input.value) {
                input.value = "+7 (";
            }
        });

        input.addEventListener("input", () => {
            let digits = input.value.replace(/\D/g, "");

            // Убираем первую 7 или 8 если пользователь ввёл её вручную
            if (digits.startsWith("7") || digits.startsWith("8")) {
                digits = digits.slice(1);
            }

            digits = digits.substring(0, 10); // максимум 10 цифр после +7

            let formatted = "+7";

            if (digits.length > 0) {
                formatted += " (" + digits.substring(0, 3);
            }
            if (digits.length >= 3) {
                formatted += ") " + digits.substring(3, 6);
            }
            if (digits.length >= 6) {
                formatted += "-" + digits.substring(6, 8);
            }
            if (digits.length >= 8) {
                formatted += "-" + digits.substring(8, 10);
            }

            input.value = formatted;
        });

        input.addEventListener("blur", () => {
            if (input.value === "+7 (") {
                input.value = "";
            }
        });
    });
}